<template>
  <section class="pricing-section">
    <v-container style="max-width: 1200px">
      <div class="text-center mb-12">
        <p class="section-eyebrow">{{ $t("pricing.eyebrow") }}</p>
        <h2 class="section-title">{{ $t("pricing.title") }}</h2>
        <p class="section-subtitle mt-4">{{ $t("pricing.subtitle") }}</p>
      </div>

      <v-row justify="center">
        <!-- Free Plan -->
        <v-col cols="12" md="4">
          <div class="plan-card">
            <p class="plan-name">{{ $t("pricing.freeName") }}</p>
            <div class="plan-price-row">
              <span class="plan-price">{{ $t("pricing.freePrice") }}</span>
              <span class="plan-period">{{ $t("pricing.period") }}</span>
            </div>
            <p class="plan-desc">Бүгд багтсан үйлчилгээ</p>
            <!-- School system banner -->
            <v-card
              flat
              class="school-banner mt-10 pa-6 d-flex flex-column"
              style="
                border-radius: 16px;
                background: #f17055;
                border: 1.5px solid #f17055;
              "
            >
              <v-icon color="#fff" size="28" class="mb-3 flex-shrink-0"
                >mdi-school-outline</v-icon
              >
              <p class="school-banner-text ma-0" style="color: #fff">
                "Багш систем" -ийн бүх багш, сурагчид үнэ төлбөргүй ашиглах
                эрхтэй
              </p>
            </v-card>
          </div>
        </v-col>

        <!-- Plus Plan -->
        <v-col cols="12" md="4">
          <div class="plan-card plan-card-featured">
            <div class="plan-badge">{{ $t("pricing.mostPopular") }}</div>
            <p class="plan-name">{{ $t("pricing.plusName") }}</p>
            <div class="plan-price-row">
              <span class="plan-price">{{ $t("pricing.plusPrice") }}</span>
              <span class="plan-period">{{ $t("pricing.period") }}</span>
            </div>
            <p class="plan-desc mb-10">{{ $t("pricing.plusDesc") }}</p>
        
            <ul class="plan-features">
              <li
                v-for="(f, i) in $t('pricing.plusFeatures')"
                :key="i"
                class="plan-feature"
              >
                <v-icon small color="primary" class="mr-2">mdi-check</v-icon>
                {{ f }}
              </li>
            </ul>
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <div class="plan-card plan-card-featured">
            <div class="plan-badge" style="background-color: #48d38c">
              Сургуулийн багц
            </div>
            <p class="plan-name">{{ $t("pricing.freeName") }}</p>
            <div class="plan-price-row">
              <span class="plan-price">1,500K₮</span>
              <span class="plan-period">жил</span>
            </div>
            <p class="plan-desc">Сургуулийн бүx багш, сурагчдад</p>
            <!-- School system banner -->
            <p class="ma-0 text-h6 text-center mt-10" style="color: #48d38c">
              Бүx үйлчилгээ багтсан
              <v-icon small color="#48d38c" class="mr-2" size="16">mdi-check</v-icon>
            </p>

            <v-btn
              color="#48d38c"
              depressed
              block
              large
              rounded
              class="plan-btn mt-6 mb-8"
              style="color: white"
              @click="dialog = true"
            >
              Сургууль бүртгүүлэx
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Registration Dialog -->
    <v-dialog v-model="dialog" max-width="480" persistent>
      <v-card style="border-radius: 20px; padding: 8px">
        <v-card-title class="dialog-title pt-6 px-6 mb-4"
          >Сургуулиа бүртгүүлэх</v-card-title
        >
        <v-card-subtitle class="dialog-sub px-6 pb-4"
          >Мэдээллийг бөглөж бидэнтэй холбогдоорой.</v-card-subtitle
        >
        <v-card-text class="px-6">
          <v-text-field
            v-model="form.school"
            label="Сургуулийн нэр"
            outlined
            dense
            rounded
            class="mb-2"
            prepend-inner-icon="mdi-school-outline"
          />
          <v-text-field
            v-model="form.phone"
            label="Утасны дугаар"
            outlined
            dense
            rounded
            class="mb-2"
            prepend-inner-icon="mdi-phone-outline"
            type="tel"
          />
          <v-text-field
            v-model="form.email"
            label="И-мэйл хаяг"
            outlined
            dense
            rounded
            prepend-inner-icon="mdi-email-outline"
            type="email"
          />
        </v-card-text>
        <v-card-actions class="px-6 pb-6" style="gap: 10px">
          <v-btn
            text
            rounded
            class="flex-grow-1"
            @click="dialog = false"
            style="text-transform: none; color: #888"
            >Цуцлах</v-btn
          >
          <v-btn
            color="primary"
            depressed
            rounded
            class="flex-grow-1"
            @click="dialog = false"
            style="text-transform: none; font-weight: 700"
            >Илгээх</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
export default {
  name: "PricingSection",
  data() {
    return {
      dialog: false,
      form: { school: "", phone: "", email: "" },
    };
  },
};
</script>

<style scoped>
.pricing-section {
  padding: 96px 16px;
  background: #f8f9fc;
}

.section-eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  color: #f77317;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 12px;
}

.section-title {
  font-size: 2.4rem;
  font-weight: 900;
  color: #1a1a2e;
  letter-spacing: -1px;
  line-height: 1.15;
  margin: 0;
}

.section-subtitle {
  font-size: 1rem;
  color: #888;
  margin: 0;
}

.plan-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  padding: 36px 32px;
  height: 100%;
  position: relative;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.07);
}

.plan-card-featured {
  border: 2px solid #171421;
  box-shadow: 0 8px 32px rgba(66, 87, 178, 0.14);
}

.plan-badge {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  background: #f17055;
  color: white;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 5px 16px;
  border-radius: 100px;
  white-space: nowrap;
}

.plan-name {
  font-size: 1rem;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0 0 8px;
}

.plan-price-row {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 8px;
}

.plan-price {
  font-size: 3rem;
  font-weight: 900;
  color: #1b1c2e;
  letter-spacing: -2px;
  line-height: 1;
}

.plan-period {
  font-size: 0.9rem;
  color: #999;
  font-weight: 500;
}

.plan-desc {
  font-size: 0.88rem;
  color: #888;
  margin: 0;
}

.plan-btn {
  text-transform: none;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0;
  height: 50px !important;
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.school-banner-text {
  font-size: 0.95rem;
  font-weight: 600;
  color: #92580a;
  line-height: 1.5;
}

.plan-feature {
  display: flex;
  align-items: center;
  font-size: 0.88rem;
  color: #444;
  font-weight: 500;
}
</style>
